
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../../providers/AuthProvider';
import { AppThemeProvider } from '../../providers/MuiThemeProvider';
import AppRouter from './AppRouter';


const App: React.FC = () => {
  return (
    <AppThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </AppThemeProvider>
  );
};

export default App;